import { z } from 'zod';

export const MdmAttributeValueSchema = z.object({
  value: z.union([z.string(), z.number(), z.boolean()]).nullable(),
  isReadOnly: z.boolean().default(false),
});
